import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Search, Sparkles } from "lucide-react";
import { Reveal, CreatorCard, creators } from "@/components/marketing/kit";
import CreatorModal from "@/components/marketing/CreatorModal";
import { TikTokIcon, InstagramIcon } from "@/components/marketing/icons";

const NICHES = ["All", "Fashion & Lifestyle", "Tech & Gaming", "Travel & Food", "Fitness & Wellness", "Beauty & Skincare", "Fitness", "Travel", "Food", "Beauty", "Streetwear", "Home & Decor", "Gaming"];

export default function Creators() {
  const [q, setQ] = useState("");
  const [platform, setPlatform] = useState("all");
  const [niche, setNiche] = useState("All");
  const [selected, setSelected] = useState(null);

  const list = useMemo(() => creators.filter(c =>
    (platform === "all" || c.platform === platform) &&
    (niche === "All" || c.niche === niche) &&
    (!q || c.name.toLowerCase().includes(q.toLowerCase()) || c.handle.toLowerCase().includes(q.toLowerCase()) || c.niche.toLowerCase().includes(q.toLowerCase()) || c.location.toLowerCase().includes(q.toLowerCase()))
  ), [q, platform, niche]);

  return (
    <main>
      <section className="mk-sec" style={{ paddingBottom: 30 }}><div className="mk-wrap mk-head">
        <Reveal><span className="mk-pill"><span className="dot" /> Live creator directory</span></Reveal>
        <Reveal delay={0.08}><h1 className="mk-h2" style={{ fontSize: "clamp(32px,4.6vw,56px)" }} data-testid="creators-title">Meet creators your audience already follows</h1></Reveal>
        <Reveal delay={0.16}><p data-testid="creators-description">A preview of the TikTok & Instagram talent inside HypeFlow — filter by platform, niche and location, then shortlist in a tap.</p></Reveal>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap">
        <div className="mk-filters" data-testid="creator-filters">
          <div className="mk-filter-search"><Search /><input placeholder="Search creators, niches, cities…" value={q} onChange={e => setQ(e.target.value)} data-testid="creator-search-input" /></div>
          <button className={`mk-filter-btn${platform === "all" ? " on" : ""}`} onClick={() => setPlatform("all")} data-testid="filter-platform-all">All</button>
          <button className={`mk-filter-btn${platform === "tiktok" ? " on" : ""}`} onClick={() => setPlatform("tiktok")} data-testid="filter-platform-tiktok"><TikTokIcon size={14} /> TikTok</button>
          <button className={`mk-filter-btn${platform === "instagram" ? " on" : ""}`} onClick={() => setPlatform("instagram")} data-testid="filter-platform-instagram"><InstagramIcon size={14} /> Instagram</button>
          <select className="mk-filter-btn" value={niche} onChange={e => setNiche(e.target.value)} data-testid="filter-niche" style={{ background: "var(--card)" }}>
            {NICHES.map(n => <option key={n} value={n}>{n === "All" ? "All niches" : n}</option>)}
          </select>
        </div>

        {list.length ? (
          <div className="mk-creator-grid" data-testid="creator-grid">
            {list.map((c, i) => <CreatorCard key={c.id} c={c} index={i} onSelect={setSelected} />)}
          </div>
        ) : <div className="mk-empty" data-testid="creator-empty">No creators match those filters yet — try widening your search.</div>}
      </div></section>

      <CreatorModal creator={selected} onClose={() => setSelected(null)} />

      <section className="mk-sec"><div className="mk-wrap"><div className="mk-cta">
        <span className="mk-pill" style={{ margin: "0 auto" }}><Sparkles size={14} /> 180M+ creators inside</span>
        <h2>Unlock the full directory with AI matching</h2>
        <p>This is a tiny sample. Inside HypeFlow you search millions of creators ranked by fit for your brief.</p>
        <div className="mk-cta-actions"><Link to="/login?mode=register" className="mk-btn primary lg" data-testid="creators-final-trial">Start free <ArrowRight size={17} /></Link></div>
      </div></div></section>
    </main>
  );
}
